import React, { useEffect } from 'react'
import PedidosYaStyle from '../../../../../assets/css/components/admin/plugins/PedidosYaStyle';
import { BiCalendar, BiCheckCircle, BiChevronDown, BiPurchaseTagAlt, BiRocket, BiSearch, BiX } from 'react-icons/bi'
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { useState, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { keyAccessToken, keyUserId } from '../../../../../assets/js/SessionStorageNames';
import DateTime from '../../../reports/components/DateTime';
import useCasheaCampaign from './api-hooks/sendCampaign';
import { getMarketplaceCampaignTheme } from '../../shared/marketplaceCampaignTheme';
import SelectEnterpriseStyle from '../../../../../assets/css/components/admin/menus/components/SelectEnterpriseStyle';

export default function Campaign() {
    const { sendCampaign} = useCasheaCampaign();
    const theme = getMarketplaceCampaignTheme('cashea');
    const sharedFieldStyle = {
        height: 48,
        borderRadius: 14,
        border: '1px solid #E7DFC1',
        boxShadow: '0 4px 14px rgba(17, 17, 17, 0.04)',
        color: theme.textPrimary,
        fontSize: 16,
        fontWeight: 500,
        fontFamily: 'inherit',
        background: '#FFFFFF',
        padding: '0 16px',
    };
    const dateInputStyle = {
        ...sharedFieldStyle,
        display: 'flex',
        alignItems: 'center',
        paddingRight: 58,
        cursor: 'pointer',
    };
    const dateButtonStyle = {
        background: '#111111',
        color: '#FFFFFF',
        boxShadow: '2px 0px 12px rgba(0, 0, 0, 0.28)',
        borderRadius: 12,
        width: 40,
        height: 40,
        right: 4,
    };
    const campaignSteps = [
        {
            id: 1,
            type: 'step',
            text: 'Debes descargar la tarifa desde el plugin de odoo antes de enviar la campaña.',
            helperText: 'Si no lo ha hecho, haz click aquí.',
            helperLink: '/admin/plugins/my-plugins/odoo-config',
        },
        {
            id: 2,
            type: 'step',
            text: 'Selecciona la fecha de inicio y la fecha de fin de la campaña.',
        },
        {
            id: 3,
            type: 'step',
            text: 'Elige la lista de precio que usarás para la campaña.',
        },
        {
            id: 4,
            type: 'step',
            text: 'Ingresa el porcentaje ficticio del precio base del producto.',
        },
        {
            id: 5,
            type: 'step',
            text: 'Define el nombre de la campaña antes de enviarla.',
        },
    ];
    const importantReminders = [
        'La tarifa debe estar en TPV',
        'Solo se enviarán productos sincronizados',
        'El precio de campaña debe ser inferior al precio base y no puede ser menor al 50% de este',
   
    ];
    const topCampaignSteps = campaignSteps.slice(0, 2);
    const bottomCampaignSteps = campaignSteps.slice(2);
    const infoChips = [
        { icon: <BiCalendar size={16} />, text: 'Configura vigencia' },
        { icon: <BiPurchaseTagAlt size={16} />, text: 'Selecciona la tarifa correcta' },
        { icon: <BiRocket size={16} />, text: 'Envía la campaña' },
    ];

    const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
    const [showBadge, setShowBadge] = useState(false);
    const [colorError, setColorError] = useState(true);
    const [error, setError] = useState('');
    const [dateOne, setDataeOne] = useState('');
    const [dateTwo, setDataeTwo] = useState('');
    const globalContext = useContext(GlobalContext);
    const [isLoad, setIsLoad] = useState(false);
    const [priceLists, setPriceLists] = useState([]);
    const [percent, setPercent] = useState('')
    const [pricesListId, setPricesListId] = useState(null);
    const [campaignName, setCampaignName] = useState('')
    const [campaignExcelFile, setCampaignExcelFile] = useState(null);
    const [openPriceListSelect, setOpenPriceListSelect] = useState(false);
    const [priceListSearchTerm, setPriceListSearchTerm] = useState('');
    const priceListSelectRef = useRef(null);
    const priceListOptions = priceLists.map((pl) => ({
        value: pl.id,
        label: pl.name,
    }));
    const selectedPriceListOption = priceListOptions.find(
        (option) => String(option.value) === String(pricesListId)
    ) || null;
    const filteredPriceListOptions = priceListOptions.filter((option) =>
        option.label.toLowerCase().includes(priceListSearchTerm.toLowerCase())
    );

    const closeBadge = (e) => {
        e.preventDefault();
        setShowBadge(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (priceListSelectRef.current && !priceListSelectRef.current.contains(event.target)) {
                setOpenPriceListSelect(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const entId = globalContext.currentEnterpriseId;
        if (!entId) return;
        setIsLoad(true);

        axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${entId}`, {
            cancelToken: axiosCancelTokenSource.token,
            headers: {
                "x-api-key": process.env.REACT_APP_API_KEY,
                "x-access-token": localStorage.getItem(keyAccessToken),
                "x-user-id": localStorage.getItem(keyUserId),
            },
        }
        ).then(resp => {
            const data = resp.data.data;
            setPriceLists(data.priceLists);
            setIsLoad(false);
        })
            .catch((error) => {
                setIsLoad(false);
                setColorError(true);
                setError(`Algo salio mal ${error}`);
            }
            );
    }, [globalContext.currentEnterpriseId]);


    const hdlSaveCampaign = () => {
        const entId = globalContext.currentEnterpriseId;
        if (!entId) {
            setColorError(true);
            setError(`Debe seleccionar la empresa`);
            setShowBadge(true);
            return;
        };

        const parsedPercent = Number(percent);
        if (percent === '' || Number.isNaN(parsedPercent) || parsedPercent < 0) {
            setColorError(true);
            setError('Debe ingresar un porcentaje valido mayor o igual a 0');
            setShowBadge(true);
            return;
        }

        setIsLoad(true)
        const selectedPriceListName = priceLists.find(pl => String(pl.id) === String(pricesListId))?.name || '';
        sendCampaign(entId, pricesListId, parsedPercent, dateOne, dateTwo, campaignName.toLocaleLowerCase(), campaignExcelFile, selectedPriceListName)
            .then((resp) => {
                console.log(resp);
                setIsLoad(false);
                setShowBadge(true)
                setColorError(false);
                setError(`Proceso ejecutado con exito`);
            })
            .catch((error) => {
                console.log('error', error);
                setIsLoad(false);
                setColorError(true);
                setError(error?.message || 'Algo salio mal');
                setShowBadge(true)
            })
    }

    const handleCampaignExcelFile = (event) => {
        const file = event.target.files?.[0] || null;
        if (!file) {
            setCampaignExcelFile(null);
            return;
        }

        const isExcel = /\.(xlsx|xls)$/i.test(file.name) || [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
        ].includes(file.type);

        if (!isExcel) {
            setCampaignExcelFile(null);
            setColorError(true);
            setError('Debe seleccionar un archivo Excel válido (.xlsx o .xls)');
            setShowBadge(true);
            event.target.value = '';
            return;
        }

        setCampaignExcelFile(file);
    }

    return (
        <>
            <PedidosYaStyle.ContBadgeError active={showBadge} error={colorError}>
                <PedidosYaStyle.Text size=".875rem" cl="#FFFFFF">
                    {error}
                </PedidosYaStyle.Text>
                <PedidosYaStyle.BtnToggleBadge onClick={(e) => closeBadge(e)}>
                    <BiX />
                </PedidosYaStyle.BtnToggleBadge>
            </PedidosYaStyle.ContBadgeError>
            <PedidosYaStyle.ContForm style={{ overflow: 'hidden', border: `1px solid ${theme.accentBorder}`, boxShadow: theme.cardShadow }}>
                <PedidosYaStyle.HeaderForm style={{ background: theme.heroGradient, borderBottom: `1px solid ${theme.accentBorder}`, padding: '0' }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            gap: 16,
                            flexWrap: 'wrap',
                            padding: '24px',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: -38,
                                right: -18,
                                width: 148,
                                height: 148,
                                borderRadius: '50%',
                                background: theme.heroGlow,
                            }}
                        />
                        <div
                            style={{
                                position: 'absolute',
                                bottom: -42,
                                left: -10,
                                width: 128,
                                height: 128,
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.12)',
                            }}
                        />
                        <div style={{ position: 'relative', zIndex: 1 }}>
                            <PedidosYaStyle.Text size="11pt" fw="600" cl={theme.accentContrast} mb="6px" mt="0" style={{ letterSpacing: '0.08em', textTransform: 'uppercase', opacity: 0.9 }}>
                                Marketplace {theme.marketplaceName}
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Text size="15pt" fw="600" cl={theme.accentContrast} mb="4px" mt="0">
                                Crear campaña de Cashea
                            </PedidosYaStyle.Text>
                        </div>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', position: 'relative', zIndex: 1 }}>
                            {infoChips.map((chip) => (
                                <div
                                    key={chip.text}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        padding: '8px 12px',
                                        borderRadius: 999,
                                        background: theme.heroChipBackground,
                                        border: theme.heroChipBorder,
                                        color: theme.accentContrast,
                                        fontSize: 13,
                                        fontWeight: 500,
                                        backdropFilter: 'blur(6px)',
                                    }}
                                >
                                    {chip.icon}
                                    <span>{chip.text}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </PedidosYaStyle.HeaderForm>
                <PedidosYaStyle.BodyForm style={{ background: theme.sectionGradient, padding: '20px 20px 24px' }}>
                    <div
                        style={{
                            marginBottom: 28,
                            padding: '20px',
                            borderRadius: 16,
                            background: theme.cardGradient,
                            border: `1px solid ${theme.accentBorder}`,
                            boxShadow: theme.cardShadow,
                        }}
                    >
                        <PedidosYaStyle.Text size="12.5pt" fw="600" cl={theme.accentStrong} mt="0" mb="6px">
                            Pasos para crear la campaña
                        </PedidosYaStyle.Text>
                        <PedidosYaStyle.Text size="10.5pt" cl={theme.textSecondary} mt="0" mb="16px">
                            Sigue esta secuencia para evitar errores al momento de enviar la campaña a Cashea.
                        </PedidosYaStyle.Text>
                        {[topCampaignSteps, bottomCampaignSteps].map((stepsGroup, groupIndex) => (
                            <div
                                key={`steps-group-${groupIndex}`}
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: groupIndex === 0
                                        ? 'repeat(2, minmax(0, 1fr))'
                                        : 'repeat(3, minmax(0, 1fr))',
                                    gap: 12,
                                    marginBottom: groupIndex === 0 ? 12 : 0,
                                }}
                            >
                                {stepsGroup.map((step) => (
                                    <div
                                        key={step.id}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: 12,
                                            padding: '14px 16px',
                                            borderRadius: 14,
                                            backgroundColor: theme.surface,
                                            border: `1px solid ${theme.stepCardBorder || theme.accentBorder}`,
                                            background: theme.surface,
                                            boxShadow: 'none',
                                        }}
                                    >
                                        <div
                                            style={{
                                                minWidth: 28,
                                                height: 28,
                                                borderRadius: '50%',
                                                background: theme.stepBadgeGradient,
                                                color: '#FFFFFF',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: 17,
                                                fontWeight: 600,
                                                marginTop: 2,
                                            }}
                                        >
                                            {step.id}
                                        </div>
                                        <div>
                                            <PedidosYaStyle.Text
                                                size="10.5pt"
                                                cl={theme.textPrimary}
                                                mt="0"
                                                mb={step.helperText ? "6px" : "0"}
                                            >
                                                {step.text}
                                            </PedidosYaStyle.Text>
                                            {step.helperText && step.helperLink && (
                                                <PedidosYaStyle.Text size="9.5pt" cl={theme.textSecondary} mt="0" mb="0">
                                                    {step.helperText}{' '}
                                                <Link
                                                    to={step.helperLink}
                                                        style={{ color: '#C62828', fontWeight: 700, textDecoration: 'underline' }}
                                                    >
                                                        Ir al plugin de Odoo
                                                </Link>
                                                </PedidosYaStyle.Text>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                    <div
                        style={{
                            marginBottom: 24,
                            padding: '16px 18px',
                            borderRadius: 14,
                            background: 'linear-gradient(135deg, #FFF4F4 0%, #FFE9E9 100%)',
                            border: '1px solid #F3B7B7',
                            boxShadow: '0 10px 24px rgba(198, 40, 40, 0.08)',
                        }}
                    >
                        <PedidosYaStyle.Text size="11pt" fw="700" cl="#C62828" mt="0" mb="8px" style={{ textAlign: 'center' }}>
                            Importante
                        </PedidosYaStyle.Text>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
                            {importantReminders.map((reminder) => (
                                <div
                                    key={reminder}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                        padding: '10px 12px',
                                        borderRadius: 10,
                                        background: '#FFFFFF',
                                        border: '1px solid #F1C4C4',
                                    }}
                                >
                                    <div
                                        style={{
                                            minWidth: 10,
                                            width: 10,
                                            height: 10,
                                            borderRadius: '50%',
                                            background: '#D62828',
                                        }}
                                    />
                                    <PedidosYaStyle.Text size="10.5pt" fw="600" cl="#7F1D1D" mt="0" mb="0">
                                        {reminder}
                                    </PedidosYaStyle.Text>
                                </div>
                            ))}
                        </div>
                    </div>
                    <PedidosYaStyle.BodyFormGrid style={{ justifyContent: 'center' }}>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="11pt" fw="500" cl={theme.textPrimary} mb="8px">
                                Nombre de la campaña
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input style={{ ...sharedFieldStyle, marginBottom: 0 }} placeholder='Nombre' onChange={(e) => setCampaignName(e.target.value)} />
                            <PedidosYaStyle.Text size="9.5pt" cl={theme.textMuted} mt="8px" mb="0">
                                Usa un nombre fácil de identificar en el listado.
                            </PedidosYaStyle.Text>
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel jsc="flex-start">
                            <PedidosYaStyle.Text size="11pt" fw="500" cl={theme.textPrimary} mb="8px">
                                Lista de Precio
                            </PedidosYaStyle.Text>
                            <SelectEnterpriseStyle.ContSelect ref={priceListSelectRef}>
                                <SelectEnterpriseStyle.SelectCustom
                                    onClick={() => setOpenPriceListSelect(!openPriceListSelect)}
                                    style={{
                                        ...sharedFieldStyle,
                                        padding: '0 14px 0 16px',
                                        height: 48,
                                        borderRadius: 14,
                                    }}
                                >
                                    <SelectEnterpriseStyle.Text
                                        size="11pt"
                                        fw="500"
                                        cl={selectedPriceListOption ? theme.textPrimary : '#A8A19A'}
                                    >
                                        {selectedPriceListOption?.label || 'Seleccione una Lista de Precio'}
                                    </SelectEnterpriseStyle.Text>
                                    <SelectEnterpriseStyle.BtnShowOptions style={{ color: '#8F7A45' }}>
                                        <BiChevronDown />
                                    </SelectEnterpriseStyle.BtnShowOptions>
                                </SelectEnterpriseStyle.SelectCustom>
                                <SelectEnterpriseStyle.ContListOptions
                                    active={openPriceListSelect}
                                    style={{
                                        borderRadius: 14,
                                        border: '1px solid #EFE5B7',
                                        boxShadow: '0 12px 32px rgba(17, 17, 17, 0.12)',
                                        top: 'calc(100% + 8px)',
                                    }}
                                >
                                    <SelectEnterpriseStyle.SearchBox>
                                        <BiSearch className="search-icon" />
                                        <input
                                            type="text"
                                            placeholder="Buscar lista de precio..."
                                            value={priceListSearchTerm}
                                            onChange={(e) => setPriceListSearchTerm(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                    </SelectEnterpriseStyle.SearchBox>
                                    <SelectEnterpriseStyle.ListEnterprises>
                                        {filteredPriceListOptions.length === 0 ? (
                                            <div style={{ padding: '12px 14px', color: theme.textMuted, fontSize: 14 }}>
                                                No se encontraron listas de precio
                                            </div>
                                        ) : (
                                            filteredPriceListOptions.map((option) => (
                                                <SelectEnterpriseStyle.ItemListEnterprise
                                                    key={option.value}
                                                    onClick={() => {
                                                        setPricesListId(option.value);
                                                        setOpenPriceListSelect(false);
                                                        setPriceListSearchTerm('');
                                                    }}
                                                    style={{
                                                        background: String(option.value) === String(pricesListId) ? '#FFFBE0' : '#FFFFFF',
                                                    }}
                                                >
                                                    <SelectEnterpriseStyle.Text size="11pt" fw="500" cl={theme.textPrimary}>
                                                        {option.label}
                                                    </SelectEnterpriseStyle.Text>
                                                </SelectEnterpriseStyle.ItemListEnterprise>
                                            ))
                                        )}
                                    </SelectEnterpriseStyle.ListEnterprises>
                                </SelectEnterpriseStyle.ContListOptions>
                            </SelectEnterpriseStyle.ContSelect>
                            <PedidosYaStyle.Text size="9.5pt" cl={theme.textMuted} mt="8px" mb="0">
                                Debe corresponder a la tarifa configurada en TPV.
                            </PedidosYaStyle.Text>
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="11pt" fw="500" cl={theme.textPrimary} mb="8px">
                                Porcentaje
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input style={{ ...sharedFieldStyle, marginBottom: 0 }} placeholder='Porcentaje' onChange={(e) => setPercent(e.target.value)} />
                            <PedidosYaStyle.Text size="9.5pt" cl={theme.textMuted} mt="8px" mb="0">
                                Campo requerido. Usa el porcentaje ficticio del precio base del producto.
                            </PedidosYaStyle.Text>
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="11pt" fw="500" cl={theme.textPrimary} mb="8px">
                                Fecha Desde
                            </PedidosYaStyle.Text>
                            <DateTime
                                setValue={setDataeOne}
                                valueDefaultText="Fecha Desde"
                                inputStyle={dateInputStyle}
                                buttonStyle={dateButtonStyle}
                            />
                            <PedidosYaStyle.Text size="9.5pt" cl={theme.textMuted} mt="8px" mb="0">
                                Inicio de vigencia de la campaña.
                            </PedidosYaStyle.Text>
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="11pt" fw="500" cl={theme.textPrimary} mb="8px">
                                Fecha Hasta
                            </PedidosYaStyle.Text>
                            <DateTime
                                setValue={setDataeTwo}
                                valueDefaultText="Fecha de Hasta"
                                inputStyle={dateInputStyle}
                                buttonStyle={dateButtonStyle}
                            />
                            <PedidosYaStyle.Text size="9.5pt" cl={theme.textMuted} mt="8px" mb="0">
                                Fecha final en la que dejará de aplicar.
                            </PedidosYaStyle.Text>
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="11pt" fw="500" cl={theme.textPrimary} mb="8px">
                                Archivo Excel de tarifa (opcional)
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                                type="file"
                                accept=".xlsx,.xls"
                                style={{ ...sharedFieldStyle, paddingTop: 12 }}
                                onChange={handleCampaignExcelFile}
                            />
                            <PedidosYaStyle.Text size="9.5pt" cl={theme.textMuted} mt="8px" mb="0">
                                Si adjuntas Excel, se usará el endpoint de campaña desde Excel.
                            </PedidosYaStyle.Text>
                        </PedidosYaStyle.ContInputAndLabel>

                    </PedidosYaStyle.BodyFormGrid>
                </PedidosYaStyle.BodyForm>
                <PedidosYaStyle.FooterForm style={{ padding: '14px 20px', alignItems: 'center', justifyContent: 'center', background: theme.surfaceAlt }}>
                    <PedidosYaStyle.BtnSend
                        disabled={isLoad}
                        onClick={hdlSaveCampaign}
                        style={{ padding: '12px 22px', borderRadius: 10, fontWeight: 600, background: theme.buttonGradient, boxShadow: theme.buttonShadow, color: theme.buttonText, minWidth: 260, textAlign: 'center' }}
                    >
                        {isLoad ? 'Enviando campaña...' : 'Enviar campaña'}
                    </PedidosYaStyle.BtnSend>
                </PedidosYaStyle.FooterForm>
            </PedidosYaStyle.ContForm>
        </>
    )
}
